export const AIValidationStatus = {
    Passed: "PASSED",
    Failed: "FAILED",
    Incomplete: "INCOMPLETE",
} as const;

/**
 * Parsed inner validation result from the Data JSON string.
 * @interface
 */
export interface IAIValidationData {
    validationStatus?: string;
    failureReason?: string;
    ruleViolations?: string[];
    confidenceScore?: string;
    summary?: string;
}

/**
 * AI Validation response data model.
 * @interface
 */
export interface IAIValidationResponse {
    data?: string;
    status?: string;
    blockUser?: string | boolean;
}